module.exports = __webpack_public_path__ + "img/oufu_65x90x12b.prt.772f1cdf.jpg";